export default __webpack_public_path__ + "static/media/forgetPass.62fbaf46.gif";